import { h, Component } from 'preact';
import { route } from 'preact-router';
import { translate } from 'react-i18next';

import Button from '../Button.js';


class ReferAFriend extends Component {

  setGameSpecificData = (game) => {
    switch (game) {
      case 'smite':
      this.setState({
        game: 'Smite',
        url: 'smitegame.com/play-for-free?ref='
			});
      break;
      case 'paladins':
      this.setState({
        game: 'Paladins',
        url: 'paladins.com/play-for-free?ref='
			});
      break;
      default:
      route('/', true);
    }
  }

  copyStringToClipboard = (str) => {
    let el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style = {position: 'absolute', left: '-9999px'};
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
 }

  copyLink = () => {
    this.copyStringToClipboard(this.state.url + this.state.player);
  }

  cancelReferral = () => {
    route('/', true);
  }

  sendReferral = () => {
    this.setState({ buttonSendReferral: 'loading' });
    if (this.state.email) {
      fetch('https://api.hirezstudios.com/acct/sendReferral', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: `{"webToken": "${this.props.userData.webToken}", "game": "${this.state.game}", "email": "${this.state.email}", "message": ""}`
				}).then((response) => response.json()).then((response) => {
					this.setState({ buttonSendReferral: 'initial' });
					if (response.statusCode === 200) {
            this.props.notification('success', 10000, `Referral sent to ${this.state.email}!`);
            this.setState({
              errorReferralEmail: undefined,
              email: undefined
            });
          } 
          else if (response.statusCode === 400) {
            this.setState({ errorReferralEmail: 'This player has already been referred or has an existing Hi-Rez Studios account.' });
          }
          else {
						this.setState({ errorReferralEmail: 'Something went wrong. Please try again.' });
					}
				})
    } 
    else {
      this.setState({
				buttonSendReferral: 'initial',
				errorReferralEmail: 'An email address is required to send a referral.'
			});
    }
  }

  checkEmail = (e) => {
    let email = e.target.value;
    let isValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    if (email.length > 0) {
      if (isValid === false) {
        this.setState({
          errorReferralEmail: 'A valid email address is required.'
        });
      } else {
        this.setState({
          errorReferralEmail: undefined
        });
      }
    } else {
      this.setState({
        errorReferralEmail: undefined
      });
    }
  }

  getPlayerName = (props) => {
    let names = {};
			props.userData.accountInfo.games.forEach(function(game) {
				names[game.game] =  {
						player: game.playerName
					};
				});
      this.setState({ gameNames: names });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props !== nextProps && nextProps.userData !== null && this.state.gameNames === null) {
     this.getPlayerName(nextProps);
    }
  }

	componentDidMount() {
    window.scrollTo(0,0);
    if (this.props.userData.accountInfo !== null) {
      this.getPlayerName(this.props);
    }
  }
  
  constructor(props, context) {
		super(props, context);
		this.state = {
			game: null,
      url: null,
      player: null,
      buttonSendReferral: 'initial',
      errorReferralEmail: '',
      gameNames: null
    };
    this.setGameSpecificData(this.props.matches.game.toLowerCase());
	}

	render() {
    const { t } = this.props;
		return (
      <div className="view-refer">
        <h1>{`${t('Refer A Friend')} - ${this.state.game}`}</h1>
        {this.state.gameNames && this.state.game &&
        <div className="refer-wrapper">
          <p>{t('Information about referring a friend can go here.')}</p>
          <div className="link-container">
            <strong>{t('Referral Link:')}</strong>
            <div>{this.state.url + this.state.gameNames[this.state.game].player}</div>
            <Button
              copy={t('Copy Link')}
              onClick={()=>this.copyStringToClipboard(this.state.url + this.state.gameNames[this.state.game].player)}
            />
          </div>
          <p>{t('Want to send a link directly? Enter in your referral\'s email below and we\'ll send it to them directly!')}</p>
          <div className="referral-email">
            <label>{t('Referral Email:')}</label>
            <div className="input-wrapper">
              <input
                key="referral-email"
                id="referral-email"
                type="email"
                onBlur={this.checkEmail}
                onInput={e => this.setState({ email: e.target.value })}
							  value={this.state.email}
              />
              <div className="error-referral-email">{t(this.state.errorReferralEmail)}</div>
            </div>
          </div>
          <div className="buttons-wrapper">
            <Button
              color="blue"
              copy={t('Submit')}
              state={this.state.buttonSendReferral}
              onClick={this.sendReferral}
            />
            <Button
              copy={t('Cancel')}
              onClick={this.cancelReferral}
            />
          </div>
        </div>
        }
      </div>
		);
	}
}

export default translate(['common'], { withRef: true })(ReferAFriend);



// WEBPACK FOOTER //
// ./components/views/ReferAFriend.js